import { render, staticRenderFns } from "./InfoStudenten.vue?vue&type=template&id=5208cfd4&scoped=true&"
import script from "./InfoStudenten.vue?vue&type=script&lang=js&"
export * from "./InfoStudenten.vue?vue&type=script&lang=js&"
import style0 from "./InfoStudenten.vue?vue&type=style&index=0&id=5208cfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208cfd4",
  null
  
)

export default component.exports